<template>
  <div class="card" style="width: 850px; height: 600px;overflow: auto;">
    <div class="card-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">Add New User</p>
        <button type="button" class="delete" @click="$emit('close')"></button>
      </header>
      <section class="">
        <div class="box" style=" margin: auto; ">
          <div class="columns is-mobile">
            <div class="column sect">
              <div class="box profile">
                <div class="has-text-centered is-centered">
                  <b-icon :icon="icon" size="is-large" type="is-primary">
                  </b-icon>
                  <p class="title is-5" style="">
                    User Information
                  </p>
                </div>

                <br />
                <b-notification
                  type="is-danger is-light"
                  class="my-3"
                  v-if="validationErrors.length > 0"
                >
                  <h4 class="is-size-5">
                    Please correct the following errors:
                  </h4>
                  <div class="content">
                    <ul>
                      <li
                        v-for="(validationError, index) in validationErrors"
                        :key="index"
                      >
                        {{ validationError }}
                      </li>
                    </ul>
                  </div>
                </b-notification>

                <div class="columns is-mobile">
                  <div class="column sect">
                    <div class="columns">
                      <div class="column">
                        <section>
                          <b-field label="Email">
                            <b-input
                              v-model="user.email"
                              required
                              type="email"
                              validation-message="Please enter a valid email address"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-4">
                        <section>
                          <b-field label="First Name">
                            <b-input
                              v-model="user.firstName"
                              required
                              validation-message="Please enter a valid name"
                              pattern="[a-zA-Z]*"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-4">
                        <section>
                          <b-field label="Middle Name">
                            <b-input
                              v-model="user.middleName"
                              pattern="[a-zA-Z]*"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-4">
                        <section>
                          <b-field label="Last Name">
                            <b-input
                              v-model="user.lastName"
                              required
                              validation-message="Please enter a valid name"
                              pattern="[a-zA-Z]*"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-half">
                        <section>
                          <b-field label="Gender">
                            <b-select
                              v-model="user.gender"
                              placeholder="Select Gender"
                              expanded
                            >
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="X">Non-Binary</option>
                            </b-select>
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-half">
                        <section>
                          <b-field label="Mobile Phone">
                            <b-input
                              v-model="user.mobilePhone"
                              v-cleave="masks.phone"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
                <b-button @click="saveUser()" type="is-primary" expanded
                  >Save Information</b-button
                >
              </div>

              <b-loading
                :is-full-page="true"
                v-model="loading"
                :can-cancel="false"
                size="is-large"
                type="is-primary"
              ></b-loading>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Cleave from "cleave.js";

const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  },
};

export default {
  directives: { cleave },

  props: ["profile"],

  data() {
    return {
      loading: false,
      icon: "alpha-u-circle",
      masks: {
        phone: {
          phone: true,
          phoneRegionCode: "US",
          delimiter: "-",
        },
      },

      user: {
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        mobilePhone: "",
        email: "",
        createTcCreds: false,
      },
      validationErrors: [],
    };
  },
  methods: {
    validateForm() {
      var errors = [];
      if (!this.user.firstName) {
        errors.push("First name is required");
      }
      if (!this.user.lastName) {
        errors.push("Last name is required");
      }
      if (!this.user) {
        errors.push("Email address is required");
      }
      this.validationErrors = errors;

      if (errors.length > 0) {
        return false;
      }

      return true;
    },

    saveUser() {
      this.validateForm();

      if (this.validateForm()) {
        this.loading = true;

        var body = { contactId: this.profile.id, user: this.user };

        this.$app
          .huddleLabsServerCall("profile/contact/add", body)
          .then((result) => {
            if (!result.error) {
              if (!result.success) {
                this.failure(result.error_message);

                this.loading = false;
              } else {
                this.loading = false;
                this.success();
                this.$emit("upload-success");
                this.$emit("close");
              }
            } else {
              this.failure(result.error_message);

              console.log(result);
              this.loading = false;
            }
          })
          .catch((error) => {
            this.loading = false;

            this.failure(error);

            console.log(error);
          });
      }
    },
    success() {
      this.$buefy.toast.open({
        message: "User Successfully added",
        type: "is-success",
      });
    },
    failure(msg = "") {
      this.$buefy.toast.open({
        duration: 5000,
        message: "There was an error creating user record" + msg,
        position: "is-bottom",
        type: "is-danger",
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
